import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BaseLayout from '../../components/BaseLayout.js';
import Card from '../../components/Card.js';
import Title from '../../components/Title.js';
import LongInput from '../../components/LongInput.js';
import ShortButton from '../../components/ShortButton.js';
import LoadingDots from '../../components/LoadingDots.js';
import { resetPassword } from '../../api/axios';

const ChangePassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [resetLoading, setResetLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');

  const navigate = useNavigate();
  const {token} = useParams();

  const validate = () => {
    const newErrors = {};
    
    if (!newPassword) {
      newErrors.newPassword = 'New password is required';
    } else if (newPassword.length < 8) {
      newErrors.newPassword = 'Password must be at least 8 characters long';
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = 'Please confirm your new password';
    } else if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }

    if (!token) {
      newErrors.miscError = 'Reset token not found. Please try resetting your password again.'
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrors({});

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setResetLoading(true);

    try {
      const response = await resetPassword(token, newPassword);
      console.log("Password changed successfully:", response.data);
      setStatusMessage("Your password has been updated successfully.");
      handleBackToLogin();
    } catch (error) {
      console.error("Error updating password:", error.response?.data || error.message);
      setErrors({miscError: error.response?.data?.message || 'Failed to update password.'});
    } finally {
      setResetLoading(false);
    }
  };

  const handleBackToLogin = () => {
    setTimeout(() => {
      navigate('/login');
    }, 300);
  };

  return (
    <>
      <style>
        {`
          .form-container {
            margin: 0 auto;
            padding: 0 24%;
            display: flex;
            flex-direction: column;
            padding-top: 6%;
          }

          .form-fields {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 24px;
            width: 100%;
            padding-top: 4%;
          }

          .input-gap {
            margin-bottom: 16px;
          }

          .button-gap {
            margin-bottom: 12px;
          }
          
          .status-message {
            width: 100%;
            color: #E1E1E6;
            text-align: center;
            font-family: 'Poppins', sans-serif;
            font-size: 12px;
            font-style: normal;
            font-weight: 300;
            line-height: 140%;
            margin-top: 16px;
          }

          .error-message {
            color: #ff4d4f;
            margin: 8px 0;
            text-align: center;
            width: 100%;
          }

          .remember-password {
            width: 100%;
            text-align: right;
          }

          .remember-password-button {
            color: #E1E1E6;
            font-family: 'Poppins', sans-serif;
            font-size: 12px;
            background: none;
            border: none;
            cursor: pointer;
          }

          .remember-password-button:hover {
            color: #9797FA;
          }
          
        `}
      </style>

      <BaseLayout>
        <div className="form-container">
          <Card>
            <Title text="Reset Your Password" />
            <form onSubmit={handleSubmit} className="form-fields">
              <LongInput 
                text="New Password"
                type="password"
                value={newPassword}
                error={errors.newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <LongInput 
                text="Confirm New Password"
                type="password"
                value={confirmPassword}
                error={errors.confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />

              <div className="remember-password button-gap">
                <button className="remember-password-button" type="button" onClick={() => window.history.back()}>
                  Go back to Login?
                </button>
              </div>

              <div className="button-gap">
                <ShortButton text={resetLoading ? <LoadingDots/> : "Reset"} type="submit" />
              </div>
              {statusMessage && (
                <div className="status-message">
                  {statusMessage}
                </div>
              )}
            </form>
            {errors.miscError && <div className="error-message">{errors.miscError}</div>}
          </Card>
        </div>
      </BaseLayout>
    </>
  );
};

export default ChangePassword;